"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdornmentRight = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AdornmentMixin = require("../../mixins/components/AdornmentMixin");
var _Adornment = require("../Adornment/Adornment.styles");
var AdornmentRight = /*#__PURE__*/(0, _styledComponents.default)(_Adornment.StyledAdornment).withConfig({
  displayName: "AdornmentRight",
  componentId: "c11n-8-107-0__sc-46k37c-0"
})(["", ""], _AdornmentMixin.AdornmentRightMixin);
exports.AdornmentRight = AdornmentRight;
AdornmentRight.displayName = 'AdornmentRight';

/** @component */